export const APPROVAL_FILTER = {
  COR_REVIEW: 'COR_REVIEW',
  DSI_REVIEW: 'DSI_REVIEW',
  PENDING: 'PENDING',
} as const;

export type ApprovalFilter = (typeof APPROVAL_FILTER)[keyof typeof APPROVAL_FILTER];

export const APPROVAL_FILTER_VALUES = Object.values(APPROVAL_FILTER) as [ApprovalFilter, ...ApprovalFilter[]];
